module.exports = __webpack_public_path__ + "img/流程-5.7f57468e.jpg";